export default {
    AppHeader: {
        language: 'Traducción',
        languageTooltip: 'Seleccione un idioma',
        languageSwitchedMessage: 'El idioma cambió a {0} correctamente.'
    }
};
